/* Instalação na tela inicial. O ícone é desenhado num canvas para não
   depender de arquivo de imagem, e o manifesto é montado em memória. */
import { $, toast } from "./util.js";
import { MARCA, NOME_PAINEL } from "./marca.js";

export function ligarPWA(){

  const cv=document.createElement("canvas"); cv.width=cv.height=512;
  const g=cv.getContext("2d");
  g.fillStyle=MARCA.preto; g.fillRect(0,0,512,512);
  /* O mesmo bitmap serve de icone comum e de maskable, e a zona segura do
     maskable e o circulo central de 80%: o lettering nao pode passar de uns
     410px. Por isso o corpo menor e o maxWidth, que aperta em vez de cortar.
     A regua amarela e o unico amarelo da marca fora do cabecalho. */
  g.fillStyle="#fff"; g.font="800 104px Archivo, Helvetica, sans-serif";
  g.textAlign="center"; g.textBaseline="middle"; g.fillText(MARCA.nome,256,244,360);
  g.strokeStyle=MARCA.amarelo; g.lineWidth=14; g.beginPath(); g.moveTo(176,322); g.lineTo(336,322); g.stroke();
  const icone=cv.toDataURL("image/png");
  $("#apLink").href=icone;
  /* Mesmo desenho na aba do navegador: nao existia favicon nenhum. */
  const ic=$("#icLink"); if(ic) ic.href=icone;
  try{
    const mf={name:NOME_PAINEL,short_name:MARCA.nome,start_url:".",scope:".",display:"standalone",
      orientation:"portrait",background_color:MARCA.papel,theme_color:MARCA.preto,
      icons:[{src:icone,sizes:"512x512",type:"image/png",purpose:"any"},{src:icone,sizes:"512x512",type:"image/png",purpose:"maskable"}]};
    $("#mfLink").href=URL.createObjectURL(new Blob([JSON.stringify(mf)],{type:"application/manifest+json"}));
  }catch(e){}
  let prompt=null;
  window.addEventListener("beforeinstallprompt",e=>{ e.preventDefault(); prompt=e; $("#btnInstalar").hidden=false; });
  $("#btnInstalar").addEventListener("click",async()=>{
    if(prompt){ prompt.prompt(); await prompt.userChoice; prompt=null; $("#btnInstalar").hidden=true; return; }
    toast("No iPhone: toque em Compartilhar e depois em Adicionar à Tela de Início.");
  });
  const iOS=/iPad|iPhone|iPod/.test(navigator.userAgent);
  const solto=!(window.matchMedia("(display-mode: standalone)").matches||navigator.standalone);
  if(iOS&&solto) $("#btnInstalar").hidden=false;
}
